import React, { useContext, useCallback, useEffect } from 'react';
import { withRouter, matchPath, useRouteMatch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar } from '@material-ui/core';
import { AuthContext } from '../../contexts/AuthContext';
import { Typography, Button } from '../../components';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: 2,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));
const labels = {
  "blh": "BLHN",
  "vpgt": "FS"
};

const toTitle = (str) =>
  str
    .split('-')
    .map((e) => e.slice(0, 1).toUpperCase() + e.slice(1).toLowerCase())
    .join(' ');

const routes = [
  {
    path: '/products/:bu/:category/:productName/templates/:templateId',
    createTitle: () => 'Create Datasheet',
  },
  {
    path: '/products/:bu/:category/:productName/edit',
    createTitle: ({ bu, category }) =>
      `Edit Product - ${labels[bu]??bu.toUpperCase()} - ${toTitle(category)}`,
  },
  {
    path: '/products/:bu/:category/by-sku/:productSku/edit',
    createTitle: ({ bu, category }) =>
      `Edit Product - ${labels[bu]??bu.toUpperCase()} - ${toTitle(category)}`,
  },
  {
    path: '/products/:bu/:category/new',
    createTitle: ({ bu, category }) =>
      `Create Product - ${labels[bu]??bu.toUpperCase()} - ${toTitle(category)}`,
  },
  {
    path: '/products-import',
    createTitle: () =>
      `Import Products`,
  },
  { path: '/products', createTitle: () => 'Products Management' },
  { path: '/upload', createTitle: () => 'Batch Upload' },
  { path: '/values', createTitle: () => 'List of Values' },
  { path: '/users/:id/edit', createTitle: () => 'Edit User' },
  { path: '/users/add', createTitle: () => 'Create User' },
  { path: '/users', createTitle: () => 'Users Management' },
];

const Navbar = (props) => {
  const { location } = props;
  const { pathname } = location;
  const { state, actions } = useContext(AuthContext);
  useRouteMatch();

  const route = routes.find((r) => matchPath(pathname, r));
  const match = matchPath(pathname, route) || {};
  const { params } = match;

  useEffect(() => {
    document.title = `PCA Admin${
      route ? ' | ' + route?.createTitle(params) : ''
    }`;
  }, [route]);

  const onLogout = useCallback(() => {
    actions.logout();
  }, [actions]);

  const classes = useStyles();
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          PCA Admin
        </Typography>
        <Typography variant="h6" className={classes.title}>
          {route?.createTitle(params)}
        </Typography>
        {state.jwt ? (
          <Button color="inherit" onClick={onLogout}>
            Logout
          </Button>
        ) : null}
      </Toolbar>
    </AppBar>
  );
};

export default withRouter(Navbar);
